/**
 * VAVCI · Relacionados con el motor nativo de recomendaciones de Shopify.
 *
 * La sección vavci-related sale del servidor con el fallback determinista (misma
 * colección). Este módulo, cuando la sección se acerca al viewport, pide a
 * routes.product_recommendations_url que Shopify renderice ESA MISMA sección con
 * los productos que elige su motor (section_id) y sustituye la rejilla.
 *
 * Si el motor no devuelve nada, la red falla o la respuesta no trae cards: no se
 * toca nada y el fallback se queda. Silencioso a propósito — el visitante nunca
 * ve un hueco ni un error.
 *
 * La URL viene del data-url que construyó Liquid en el servidor (routes.* + IDs
 * de Shopify): el cliente no compone URLs. El quick-add va delegado en document
 * (vavci-quick-add.js), así que las cards inyectadas funcionan sin re-init.
 */
const MARGIN = '600px'; // pide al motor un poco antes de que el bloque asome

async function swap(section, grid) {
  try {
    const res = await fetch(section.dataset.url, { headers: { Accept: 'text/html' } });
    if (!res.ok) return;
    const html = await res.text();
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.vprod__grid');
    // Sin cards (motor sin resultados para este producto) → el fallback se queda.
    if (!fresh || !fresh.children.length) return;
    grid.innerHTML = fresh.innerHTML;
    // El track sobrevive al swap (solo cambia su innerHTML) y los listeners del
    // slider siguen vivos, pero el nº de cards puede variar: un scroll sintético
    // fuerza el update() del slider (flechas + is-enhanced) con el ancho nuevo.
    grid.dispatchEvent(new Event('scroll'));
  } catch (e) { /* red caída → fallback */ }
}

function init(section) {
  const grid = section.querySelector('.vprod__grid');
  if (!grid) return;
  const load = () => swap(section, grid);

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      if (entries.some((en) => en.isIntersecting)) { io.disconnect(); load(); }
    }, { rootMargin: MARGIN });
    io.observe(section);
  } else {
    load();
  }
}

document.querySelectorAll('[data-vc-recs][data-url]').forEach(init);
